<template>
  <div>
    <el-input :size="size" v-if="readonly" ref="input" :value="readonlyText" :placeholder="placeholder" readonly/>
    <el-cascader
      ref="cascaderRef"
      v-model="defaultValue"
      :options="options"
      :props="props"
      :placeholder="placeholder"
      clearable
      filterable
      @blur="handleBlur"
      @change="handleChange"
      style="width: 100%;">
    </el-cascader>
  </div>
</template>
<script>
import { getCategoryLists } from '@/api/PlatformSales/Category';
export default {
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    size: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default () {
        return '请选择分类';
      },
    },
    checkStrictly: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      readonlyText: '',
      defaultValue: [],
      options: [],
      dataCache: new Map(),
      props: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: this.checkStrictly,
      },
    };
  },
  methods: {
    handleBlur () {
      this.$emit('handleValidate');
    },
    handleChange (value) {
      const selectedNodes = this.$refs.cascaderRef.getCheckedNodes();
      const selectedPathLabel = selectedNodes?.length ? selectedNodes[0].pathLabels.join(',') : '';
      this.$emit('handleSelect', { value, selectedPathLabel });
    },
    async queryCategoryLists () {
      const res = await getCategoryLists({ parentId: '1747442419689152512', enableFlag: true });
      if (res.heads.code === 200) {
        this.options = res.body || [];
      }
    },
  },
  created () {
    this.queryCategoryLists();
  },
};
</script>
